export default function ProjectDetailsSection() {
	return (
		<div className="fugu-gallery-data4">
			<h4>Project Details:</h4>
			<p>
				By partnering with cross-functional teams and customers, for you will turn your insights into there is a
				delightful creative environment that requires proven leadership skills and the ability to the skill.
			</p>
			<ul>
				<li>
					<span>Client:</span>
					Adam Smith
				</li>
				<li>
					<span>Category:</span>
					Digital Art
				</li>
				<li>
					<span>Duration:</span>1 Week
				</li>
				<li>
					<span>Website Link:</span>
					example@xyzgmail.com
				</li>
			</ul>
		</div>
	);
}
